import { IOrganization } from 'common/src/types/interfaces';
import { RequiredContactFields } from 'common/src/validators/esValidationFields';

export function someOrgEsContactFieldsExist({
  esContactAddress1,
  esContactAddress2, // If this field exists, we want to flag the user other fields are required.
  esContactCity,
  esContactEmail,
  esContactFirstName,
  esContactJobTitle,
  esContactLastName,
  esContactPhone,
  esContactPostalCode,
  esContactState,
}: RequiredContactFields & Pick<IOrganization, 'esContactAddress2'>): boolean {
  return [
    esContactAddress1,
    esContactAddress2,
    esContactCity,
    esContactEmail,
    esContactFirstName,
    esContactJobTitle,
    esContactLastName,
    esContactPhone,
    esContactPostalCode,
    esContactState,
  ].some(Boolean);
}

export function allOrgEsContactFieldsExist({
  esContactAddress1,
  // address 2 is not required, so don't include it in this check.
  esContactCity,
  esContactEmail,
  esContactFirstName,
  esContactJobTitle,
  esContactLastName,
  esContactPhone,
  esContactPostalCode,
  esContactState,
}: RequiredContactFields): boolean {
  return [
    esContactAddress1,
    esContactCity,
    esContactEmail,
    esContactFirstName,
    esContactJobTitle,
    esContactLastName,
    esContactPhone,
    esContactPostalCode,
    esContactState,
  ].every(Boolean);
}
